module.exports = __webpack_public_path__ + "img/93-256.0539c6b6.png";